import { useState } from 'react';
import { campaign } from './campaign';
import '../../styles/Campaign.css';
import '../../styles/CampaignLoginPanel.css';

/**
 * Contenido de campaña para el panel oscuro del login (HU-016, lámina 05) —
 * reemplaza TODO el contenido de `.panel-login-panel-marca` cuando hay
 * banner configurado (logo institucional incluido), no solo un bloque
 * intermedio: el mockup agrupa todo en 2 franjas separadas por el
 * `justify-content: space-between` que ya trae `.panel-login-panel-marca`
 * (Panel.css) — arriba identidad+banner, abajo estado+título+pilares — por
 * eso este componente devuelve un fragmento con esas 2 franjas como hijos
 * directos, en vez de envolverlas en un único div. Sin `configuracion.banner`,
 * `PanelLogin.jsx` ni siquiera monta esto (usa su logo/título por defecto).
 */
const CampaignLoginPanel = ({ configuracion }) => {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  // El tilt es puramente JS (no hay forma de expresarlo solo en CSS con la
  // posición real del mouse) — por eso el apagado por movimiento reducido
  // vive acá, no en el CSS compartido (Campaign.css).
  const manejarMovimiento = (evento) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const rect = evento.currentTarget.getBoundingClientRect();
    const px = (evento.clientX - rect.left) / rect.width;
    const py = (evento.clientY - rect.top) / rect.height;
    setTilt({ x: (0.5 - py) * 10, y: (px - 0.5) * 14 });
  };

  const resetear = () => setTilt({ x: 0, y: 0 });

  const altBanner = `${campaign.party} — ${campaign.candidate}${configuracion.slogan ? `, ${configuracion.slogan}` : ''}`;

  return (
    <>
      <div className="clp-superior">
        <div className="clp-identidad">
          <div className="panel-login-logo">
            {configuracion.logo
              ? <img src={configuracion.logo} alt={configuracion.nombre_entidad} />
              : <span>{configuracion.nombre_entidad?.[0] || 'C'}</span>}
          </div>
          <div className="clp-identidad-texto">
            <strong>{configuracion.nombre_entidad || 'Cifra Negra'}</strong>
            <span>CONSOLA</span>
          </div>
        </div>

        <div className="clp-banner-zona" onMouseMove={manejarMovimiento} onMouseLeave={resetear}>
          {/* El tilt (inline, sigue el mouse) y el zoom Ken Burns (CSS continuo)
              son dos transforms distintos — si fueran al mismo elemento se
              pisarían entre sí. El tilt va en este contenedor, el zoom en la
              imagen de adentro. */}
          <div
            className="clp-banner-tilt"
            style={{ transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)` }}
          >
            <img src={configuracion.banner} alt={altBanner} className="clp-banner cn-kb" />
          </div>
        </div>
      </div>

      <div className="clp-inferior">
        <div className="clp-estado">
          <span className="cn-punto-vivo clp-punto"></span>
          Sistema operativo
        </div>

        <h1 className="clp-titulo">Consola de operaciones</h1>

        <div className="clp-pilares">
          {campaign.pillars.map((pilar, indice) => (
            <span
              key={pilar}
              className={`clp-pilar-chip ${indice === campaign.pillars.length - 1 ? 'clp-pilar-chip-magenta' : ''}`}
            >
              {pilar}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default CampaignLoginPanel;
